import React from 'react';
import tw, { styled } from 'twin.macro';

import IMAGES from '../../assets/images';
import { useSite } from '../../hooks/use-site';
import UsersShipmentFormComponent from '../../components/users/shipment-form';

const BgImage = styled.img`
  top: 0;
  width: 18rem;
  height: auto;
  ${tw`absolute z-0 left-[-2rem] md:left-[-1rem]`};
`;

function QuestionnaireShipmentPageComponent() {
  const { isAllergomedica } = useSite();

  return (
    <div className="min-h-full md:flex items-center justify-center py-10 md:py-20 px-4 sm:px-6 lg:px-8 mx-auto max-w-7xl relative">
      {isAllergomedica && <BgImage src={IMAGES.BLOB.FIRST} alt="" aria-hidden="true" />}
      <div className="md:w-3/5 z-10 relative pb-10 md:pb-0">
        <UsersShipmentFormComponent isQuestionnaire />
      </div>
    </div>
  );
}

export default QuestionnaireShipmentPageComponent;
